import { Injectable } from '@angular/core';
import { firstValueFrom, Observable, takeUntil, timeout } from 'rxjs';
import { BaseService } from '../base/base.service';

@Injectable({
  providedIn: 'root'
})
export class ImageHelperService {

  constructor(private baseService: BaseService) { }

  async formHasImage<T>(formData: T,
    destroy$: Observable<any>) {

    try {
      const res = await firstValueFrom(
        this.baseService.addImage.pipe(
          timeout(3000),
          takeUntil(destroy$)
        )
      );
      console.log('Received addImage:', res);
      const ImageId = res?.id;
      const imagekey = res?.formKey;
      console.log('ImageId:', ImageId, 'ImageKey:', imagekey);
      // Update formData with ImageId if it exists
      if (ImageId && imagekey) {
        console.log('Setting formData with ImageId:', ImageId);
        formData[imagekey] = ImageId;
        return formData;
      }
    } catch (err) {
      console.error('Error waiting for addImage or timeout:', err);
      // Proceed without ImageId if no emission (image is optional)
      console.log('No image data received, proceeding with formData:', formData);
    }
    return null
  }
}
